import React from 'react';
import IntegrationDocTemplate from '../../../../components/IntegrationDocTemplate';

export default function DocsNetSuite() {
  return (
    <IntegrationDocTemplate
      title="NetSuite (SuiteTalk REST)"
      category="OMS / ERP"
      status="live"
      summary="NetSuite REST + SuiteQL + SuiteScript integration. Sales Orders, Inventory Adjustments, financial events. OAuth 2.0 (preferred) or token-based auth. Account-specific URLs. Best for enterprises consolidating ERP."
      prerequisites={[
        'NetSuite account (any edition).',
        'REST Web Services + Token-Based Authentication permissions enabled.',
        'Integration application + OAuth credentials in NetSuite admin → Setup → Integration → Manage Integrations.',
        'Account ID (find in NetSuite URL).',
      ]}
      connectSteps={[
        'Send us your account ID + OAuth access token via Talk to Sales (enterprise onboarding).',
        'We configure SuiteTalk REST + SuiteQL queries for your specific record types.',
        'First sync: customers + items + sales orders.',
        'Optional: nightly reconciliation job runs at 2am UTC.',
      ]}
      syncedData={[
        { type: 'Sales Orders', detail: 'CI orders mirror as NetSuite SO records with item lines + customer ref' },
        { type: 'Inventory Adjustments', detail: 'CI inventory changes post as adjustments with location + qty delta' },
        { type: 'Customers', detail: 'Bidirectional sync with NetSuite customer records' },
        { type: 'Items', detail: 'Items master mirrored both ways' },
        { type: 'Financials', detail: 'Payment + refund events via Financial Events API' },
      ]}
      agents={[
        { id: 'erp_sync_agent', name: 'erp_sync_agent', role: 'Mirrors CI orders/inventory/items to NetSuite in real-time' },
        { id: 'erp_reconciliation_agent', name: 'erp_reconciliation_agent', role: 'Nightly drift detection — flags CI ↔ NetSuite mismatches' },
        { id: 'head_finance', name: 'head_finance', role: 'Director coordinating ERP sync + financial reporting' },
      ]}
      troubleshooting={[
        { question: 'SuiteQL query slow', answer: 'NetSuite query performance depends on indexes. Use targeted WHERE clauses on indexed fields (id, externalid, lastmodifieddate).' },
        { question: 'Reconciliation flagged drift', answer: 'CI and NetSuite use different IDs by default. Set externalid on NetSuite records to your CI order/item IDs to make reconciliation reliable.' },
      ]}
      supportLink="/contact"
    />
  );
}
